import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SiteShell from './layout/SiteShell';
import Home from './pages/Home';
import ServicesHub from './pages/ServicesHub';
import ServicesAiServices from './pages/ServicesAiServices';
import ServicesAiConsulting from './pages/ServicesAiConsulting';
import ServicesAiSecurity from './pages/ServicesAiSecurity';
import ServicesRiskManagement from './pages/ServicesRiskManagement';
import ServicesHumanResources from './pages/ServicesHumanResources';
import ServicesHumanTrust from './pages/ServicesHumanTrust';
import SolutionsTrustScore from './pages/SolutionsTrustScore';
import SolutionsDeepStrike from './pages/SolutionsDeepStrike';
import SolutionsCopilotReady from './pages/SolutionsCopilotReady';
import SolutionsAiSecurity from './pages/SolutionsAiSecurity';
import SolutionsGovernance from './pages/SolutionsGovernance';
import SolutionsSecurityForAi from './pages/SolutionsSecurityForAi';
import ResearchPage from './pages/ResearchPage';
import ReinforceProject from './pages/ReinforceProject';
import UseCases from './pages/UseCases';
import GuardFort from './components/GuardFort';
import ModelFort from './components/ModelFort';
import AiGov from './components/AiGov';
import ScanFort from './components/ScanFort';
import RiskFort from './components/RiskFort';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import Applications from './components/research/Applications';
import ResourcesPage from './components/Resources';
import ResourceArticle from './pages/ResourceArticle';
import TermsOfService from './TermsAndServices';
import CookiePolicy from './CookiePolicy';
import './App.css';

function withShell(Page) {
  return (
    <SiteShell>
      <Page />
    </SiteShell>
  );
}

function RedirectToAiSecurity() {
  return <Navigate to="/services/ai-security" replace />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={withShell(Home)} />
          <Route path="/services" element={withShell(ServicesHub)} />
          <Route path="/services/ai-services" element={withShell(ServicesAiServices)} />
          <Route path="/services/ai-consulting" element={withShell(ServicesAiConsulting)} />
          <Route path="/services/ai-security" element={withShell(ServicesAiSecurity)} />
          <Route path="/services/risk-management" element={withShell(ServicesRiskManagement)} />
          <Route path="/services/human-resources" element={withShell(ServicesHumanResources)} />
          <Route path="/services/human-trust" element={withShell(ServicesHumanTrust)} />
          <Route path="/services/cybersecurity" element={withShell(RedirectToAiSecurity)} />
          <Route path="/solutions/ai-security" element={withShell(SolutionsAiSecurity)} />
          <Route path="/solutions/trustscore" element={withShell(SolutionsTrustScore)} />
          <Route path="/solutions/deepstrike" element={withShell(SolutionsDeepStrike)} />
          <Route path="/solutions/copilotready" element={withShell(SolutionsCopilotReady)} />
          <Route path="/solutions/governance" element={withShell(SolutionsGovernance)} />
          <Route path="/solutions/security-for-ai" element={withShell(SolutionsSecurityForAi)} />
          <Route path="/research" element={withShell(ResearchPage)} />
          <Route path="/research/projects/reinforce" element={withShell(ReinforceProject)} />
          <Route path="/use-cases" element={withShell(UseCases)} />
          <Route path="/guardfort" element={withShell(GuardFort)} />
          <Route path="/modelfort" element={withShell(ModelFort)} />
          <Route path="/aigov" element={withShell(AiGov)} />
          <Route path="/scanfort" element={withShell(ScanFort)} />
          <Route path="/riskfort" element={withShell(RiskFort)} />
          <Route path="/aboutus" element={withShell(AboutUs)} />
          <Route path="/applications" element={withShell(Applications)} />
          <Route path="/contactus" element={withShell(ContactUs)} />
          <Route path="/privacypolicy" element={withShell(PrivacyPolicy)} />
          <Route path="/terms" element={withShell(TermsOfService)} />
          <Route path="/cookiepolicy" element={withShell(CookiePolicy)} />
          <Route path="/resources" element={withShell(ResourcesPage)} />
          <Route path="/resources/:slug" element={withShell(ResourceArticle)} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
